// painel-admin/src/pages/ImportarOperacaoTikpag.jsx

import { useState } from "react";
import axios from "../axiosConfig";
import {
  AlertTriangle,
  CheckCircle2,
  CreditCard,
  Eye,
  Mail,
  PackageCheck,
  Search,
  ShieldCheck,
  X,
} from "lucide-react";
import { Link } from "react-router-dom";

import "./ImportarOperacaoTikpag.css";

function ImportarOperacaoTikpag() {
  const [emailFuncionario, setEmailFuncionario] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [detalhes, setDetalhes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [aprovado, setAprovado] = useState(false);

  const getMensagemErro = (err, fallback) => {
  return (
    err.response?.data?.mensagem ||
    err.response?.data?.error ||
    err.response?.data?.detalhe ||
    fallback
  );
};

const handleBuscarOperacao = async (e) => {
  e.preventDefault();

  setMensagem("");
  setDetalhes(null);
  setAprovado(false);
  setLoading(true);

  try {
    const resp = await axios.post(
      "/admin/importar-operacao-tikpag/preview",
      {
        emailFuncionario,
        numero_pedido: numeroPedido,
      }
    );

    if (!resp.data) {
      setMensagem("Nenhum dado retornado para esse pedido.");
      return;
    }

    setMensagem("Confira os dados antes de aprovar a importação.");
    setDetalhes(resp.data);

  } catch (err) {
    console.error("Erro ao buscar operação Tikpag:", err);

    setMensagem(
      getMensagemErro(
        err,
        "Não foi possível buscar esta operação. Confira o número do pedido e o e-mail do funcionário."
      )
    );
  } finally {
    setLoading(false);
  }
};

const handleAprovar = async () => {
  if (!detalhes) return;

  setLoading(true);
  setMensagem("");

  try {
    const resp = await axios.post(
      "/admin/importar-operacao-tikpag",
      {
        emailFuncionario,
        numero_pedido: numeroPedido,
      }
    );

    setMensagem(
      resp.data.mensagem ||
      "Operação importada e aprovada com sucesso!"
    );

    setDetalhes(resp.data);
    setAprovado(true);

  } catch (err) {
    console.error("Erro ao aprovar operação Tikpag:", err);

    setMensagem(
      getMensagemErro(
        err,
        "Não foi possível aprovar esta operação. Tente novamente."
      )
    );
  } finally {
    setLoading(false);
  }
};

  const handleCancelarResumo = () => {
    setDetalhes(null);
    setMensagem("Importação cancelada. Nenhuma operação foi criada.");
    setAprovado(false);
  };

  const formatarMoeda = (valor) =>
    Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  const formatarNumero = (valor) =>
    Number(valor || 0).toLocaleString("pt-BR", {
      maximumFractionDigits: 0,
    });

  return (
    <div className="importarOperacaoTikpagAdmin-page">
      <div className="importarOperacaoTikpagAdmin-topbar">
        <div>
          <span className="importarOperacaoTikpagAdmin-kicker">
            Operações Tikpag
          </span>

          <h2>Importar operação da Tikpag</h2>

          <p>
            Busque uma operação aprovada na Tikpag, confira os dados e aprove a
            importação para criar a operação no Tikpontos com crédito automático
            de pontos.
          </p>
        </div>
      </div>

      <div className="importarOperacaoTikpagAdmin-tabs">
        <span className="importarOperacaoTikpagAdmin-tab active">
          Pontos
        </span>
        <Link to="/admin/importar-pix" className="importarOperacaoTikpagAdmin-tab">
          Pix
        </Link>
      </div>

      {mensagem && (
        <div
          className={`importarOperacaoTikpagAdmin-alert ${
            aprovado ? "success" : detalhes ? "info" : "warning"
          }`}
        >
          {aprovado ? <CheckCircle2 size={16} /> : <AlertTriangle size={16} />}
          <span>{mensagem}</span>
        </div>
      )}

      <div className="importarOperacaoTikpagAdmin-card">
        <div className="importarOperacaoTikpagAdmin-cardHeader">
          <div className="importarOperacaoTikpagAdmin-icon">
            <Search size={20} />
          </div>

          <div>
            <h3>Buscar operação</h3>
            <span>
              Informe o funcionário Tikpontos e o número do pedido aprovado na
              Tikpag.
            </span>
          </div>
        </div>

        <form
          onSubmit={handleBuscarOperacao}
          className="importarOperacaoTikpagAdmin-form"
        >
          <div className="importarOperacaoTikpagAdmin-field">
            <label>E-mail do funcionário</label>

            <div className="importarOperacaoTikpagAdmin-inputIcon">
              <Mail size={15} />

              <input
                type="email"
                value={emailFuncionario}
                onChange={(e) => setEmailFuncionario(e.target.value)}
                required
                placeholder="ex: sumaya.souza@roqueimoveis.com.br"
              />
            </div>
          </div>

          <div className="importarOperacaoTikpagAdmin-field">
            <label>Número do pedido Tikpag</label>

            <div className="importarOperacaoTikpagAdmin-inputIcon">
              <CreditCard size={15} />

              <input
                type="text"
                value={numeroPedido}
                onChange={(e) => setNumeroPedido(e.target.value.replace(/\D/g, ""))}
                required
                placeholder="Somente números"
              />
            </div>
          </div>

          <button
            type="submit"
            className="importarOperacaoTikpagAdmin-btn primary"
            disabled={loading}
          >
            <Search size={16} />
            {loading ? "Buscando operação..." : "Buscar operação"}
          </button>
        </form>
      </div>

      {detalhes && (
        <div className="importarOperacaoTikpagAdmin-card">
          <div className="importarOperacaoTikpagAdmin-cardHeader">
            <div className="importarOperacaoTikpagAdmin-icon teal">
              <Eye size={20} />
            </div>

            <div>
              <h3>Resumo da operação localizada</h3>
              <span>
                Confirme os dados antes de criar a operação e creditar os pontos.
              </span>
            </div>
          </div>

          <div className="importarOperacaoTikpagAdmin-resumo">
            <div className="importarOperacaoTikpagAdmin-resumoGrid">
              <div className="importarOperacaoTikpagAdmin-resumoItem">
                <span>Funcionário</span>
                <strong>{detalhes.nome_usuario || detalhes.nome_cliente || "—"}</strong>
              </div>

              <div className="importarOperacaoTikpagAdmin-resumoItem">
                <span>E-mail</span>
                <strong>
                  {detalhes.email_usuario || detalhes.email_cliente || emailFuncionario}
                </strong>
              </div>

              <div className="importarOperacaoTikpagAdmin-resumoItem">
                <span>Nº Pedido Tikpag</span>
                <strong>{detalhes.numero_pedido || numeroPedido}</strong>
              </div>

              <div className="importarOperacaoTikpagAdmin-resumoItem">
                <span>Valor da operação</span>
                <strong>{formatarMoeda(detalhes.valor)}</strong>
              </div>

              <div className="importarOperacaoTikpagAdmin-resumoItem">
                <span>Parcelas</span>
                <strong>{detalhes.numero_parcelas ?? "—"}</strong>
              </div>

              <div className="importarOperacaoTikpagAdmin-resumoItem">
                <span>Pagador</span>
                <strong>{detalhes.nome_pagador || "—"}</strong>
              </div>

              <div className="importarOperacaoTikpagAdmin-resumoItem destaque">
                <span>Pontos a creditar</span>
                <strong>{formatarNumero(detalhes.pontos_creditados)} pts</strong>
              </div>
            </div>

            <div className="importarOperacaoTikpagAdmin-info">
              <ShieldCheck size={16} />
              <span>
                Ao aprovar, a operação será criada como <strong>aprovada</strong>{" "}
                e os pontos serão creditados automaticamente para o funcionário
                informado.
              </span>
            </div>
          </div>

          <div className="importarOperacaoTikpagAdmin-actions">
            <button
              type="button"
              onClick={handleCancelarResumo}
              disabled={loading}
              className="importarOperacaoTikpagAdmin-btn secondary"
            >
              <X size={16} />
              Cancelar
            </button>

            <button
              type="button"
              onClick={handleAprovar}
              disabled={loading || aprovado}
              className={`importarOperacaoTikpagAdmin-btn ${
                aprovado ? "success" : "primary"
              }`}
            >
              {aprovado ? (
                <>
                  <CheckCircle2 size={16} />
                  Operação aprovada
                </>
              ) : (
                <>
                  <PackageCheck size={16} />
                  {loading ? "Aprovando..." : "Aprovar e creditar pontos"}
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImportarOperacaoTikpag;